import { Button, Tag } from '@blueprintjs/core'
import React, { useContext, useMemo } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { BoxClass, NodeById } from '../../../../helper/classes'
import { GlobalContext, globalOnDemandVars } from '../../../../helper/context'
import { truncateDefault } from '../../../../helper/functions'
import LevelTag, { getLevel } from '../../../commonInterface/levelTag'
import { useTranslation } from 'react-i18next'

function SharingInfoAddOn () {
  const context = useContext(GlobalContext)
  const userEmail = useMemo(() => (context.configReady ? globalOnDemandVars.email() : null), [context.configReady])
  const sharedNode = useMemo(() => (context.treeNodesReady ? globalOnDemandVars.sharedNode() : null), [context.treeNodesReady])
  const sharedNodeObject = useMemo(() => (new NodeById(sharedNode ? sharedNode.id : 'rootNode')), [sharedNode])
  const level = useMemo(() => (getLevel(globalOnDemandVars.totalSynapses(), globalOnDemandVars.memorizeRunRecord().length, globalOnDemandVars.memorizeCompleteRecord().length)), [])

  const { t } = useTranslation()

  return useMemo(() => (!(context.configReady && context.treeNodesReady) ? null : (
    <div css={css`text-align: center; & > div { margin-bottom: var(--s-2); }`}>
      <br />
      <div>This page is shared by</div>
      <div>
        <Tag minimal large>{userEmail === 'anonymous' ? t('ANONYMOUS') : `${userEmail}`}</Tag>
      </div>
      <div>
        <LevelTag level={level} />
      </div>
      <br />
      <div>The shared node is</div>
      <div>
        <Tag minimal large title={sharedNode ? sharedNode.title : globalOnDemandVars.topRootName()}
              css={css`&:hover { cursor: pointer; }`}
              onClick={() => { sharedNodeObject.onClick() }}>{truncateDefault(sharedNode ? sharedNode.title : globalOnDemandVars.topRootName())}</Tag>
      </div>
    </div>
  )

  )
  , [context.configReady, context.treeNodesReady, level, sharedNode, sharedNodeObject, userEmail])
}

const SharingInfoAddOnBoxClass = new BoxClass(SharingInfoAddOn, 'Sharing Information', null, 'sharing', { order: 2, defaultOpen: true })

export default SharingInfoAddOnBoxClass

export { SharingInfoAddOn }
